<script>
    import { createEventDispatcher } from 'svelte';
	import { slide } from "svelte/transition";
    import Icon from "./icon.svelte";
	
    const dispatch = createEventDispatcher();
    
    export let entry

	let isOpen = false
	const toggle = () => isOpen = !isOpen

    const changeStatus = (uid, has) => {
        console.log(uid, has);
        dispatch(`changeStatus`, { uid: uid, has: has });
    };
</script>

<section class="flex space-x-2 justify-between" >      
    <div class:selected={entry.has} class="place-self-center capitalize p-4 cursor-pointer" on:click|stopPropagation="{() => changeStatus(entry.uid, !entry.has)}">
        {entry.name}
    </div>
    <span class="place-self-center italic text-sm cursor-pointer" on:click|stopPropagation={toggle}> 
        {#if entry.reco.length > 0 }
            {#if !isOpen }Want one?{:else}Collapse{/if} 
        {/if}      
    </span>
</section>

{#if isOpen}
<section class="place-self-center flex flex-col space-y-4.5" transition:slide={{ duration: 300 }}>
    {#each entry.reco as reco}
    <section class="flex space-x-1.5">
        <div class="w-24 shrink-0 flex">
            <img class="place-self-center" src="{reco.img}" alt="">
        </div>
        <section class="flex flex-col space-y-1.5">
            <span class="font-semibold italic">
                The {reco.type} option
            </span>
            <span class="font-extrabold">
                {reco.name}
            </span>
            <section class="flex justify-between">
                <section class="flex space-x-0">
                    {#if reco.price == 1}
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-shade" width="16" />
                        <Icon name="dollar-shade" width="16" />
                        <Icon name="dollar-shade" width="16" />
                    {:else if reco.price == 2}
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-shade" width="16" />
                        <Icon name="dollar-shade" width="16" />
                    {:else if reco.price == 3}
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-shade" width="16" />
                    {:else}
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-primary" width="16" />
                        <Icon name="dollar-primary" width="16" />
                    {/if}
                </section>
                <a class="place-self-end w-22 grow-0" target="_blank" href={reco.link}>
                    <section class="text-sm text-secondary grow-0 h-6 italic flex space-x-1 bg-primary rounded-3xl px-1.5">
                        <span class="">Check on </span>
                        <img src="/img/stores/4e3a.png" alt="" class="w-3 h-3 mt-1.5">
                    </section>
                </a>
            </section>
            
        </section>
    </section>
    <span class="">{reco.desc}</span>
    
        
    {/each}
</section>
{/if}

<style lang="postcss">
    .selected {
        @apply border-2 border-primary rounded-3xl;
    }
</style>